
export enum RuleActiveTypeCd {
	INACTIVE = 'Inactive',
	PRODUCTION = 'Production',
	TEST = 'Test'}

